import { createTheme } from '@mui/material/styles';
import { theme as baseTheme } from '@ddc-webplatform/cmsc-components';

const theme = createTheme(baseTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize'
        }
      }
    },
    MuiTooltip: {
      defaultProps: {
        PopperProps: {
          sx: { zIndex: 99999 }
        }
      }
    }
  },
  typography: {},
  palette: {}
});

export default theme;
